export default {
    data: [{
            timezone: 'Pacific/Tongatapu',
            offset: -46800,
            display: 'GMT+13:00',
            name: 'Nuku\'alofa'
        },
        {
            timezone: 'Pacific/Auckland',
            offset: -46800,
            display: 'GMT+12:00',
            name: 'Auckland, Wellington'
        },
        {
            timezone: 'Etc/GMT-12',
            offset: -43200,
            display: 'GMT+12:00',
            name: 'Fiji, Kamchatka, Marshall Is.'
        },
        {
            timezone: 'Asia/Magadan',
            offset: -43200,
            display: 'GMT+12:00',
            name: 'Magadan'
        },
        {
            timezone: 'Etc/GMT-11',
            offset: -39600,
            display: 'GMT+11:00',
            name: 'Solomon Is., New Caledonia'
        },
        {
            timezone: 'Asia/Vladivostok',
            offset: -39600,
            display: 'GMT+11:00',
            name: 'Vladivostok'
        },
        {
            timezone: 'Asia/Yakutsk',
            offset: -36000,
            display: 'GMT+10:00',
            name: 'Yakutsk'
        },
        {
            timezone: 'Australia/Brisbane',
            offset: -36000,
            display: 'GMT+10:00',
            name: 'Brisbane'
        },
        {
            timezone: 'Australia/Sydney',
            offset: -39600,
            display: 'GMT+10:00',
            name: 'Canberra, Melbourne, Sydney'
        },
        {
            timezone: 'Australia/Hobart',
            offset: -39600,
            display: 'GMT+10:00',
            name: 'Hobart'
        },
        {
            timezone: 'Australia/Adelaide',
            offset: -37800,
            display: 'GMT+09:30',
            name: 'Adelaide'
        },
        {
            timezone: 'Australia/Darwin',
            offset: -34200,
            display: 'GMT+09:30',
            name: 'Darwin'
        },
        {
            timezone: 'Asia/Irkutsk',
            offset: -32400,
            display: 'GMT+09:00',
            name: 'Irkutsk, Ulaan Bataar'
        },
        {
            timezone: 'Asia/Tokyo',
            offset: -32400,
            display: 'GMT+09:00',
            name: 'Osaka, Sapporo, Tokyo'
        },
        {
            timezone: 'Asia/Seoul',
            offset: -32400,
            display: 'GMT+09:00',
            name: 'Seoul'
        },
        {
            timezone: 'Asia/Hong_Kong',
            offset: -28800,
            display: 'GMT+08:00',
            name: 'Beijing, Chongqing, Hong Kong, Urumqi'
        },
        {
            timezone: 'Asia/Krasnoyarsk',
            offset: -28800,
            display: 'GMT+08:00',
            name: 'Krasnoyarsk'
        },
        {
            timezone: 'Australia/Perth',
            offset: -28800,
            display: 'GMT+08:00',
            name: 'Perth'
        },
        {
            timezone: 'Asia/Taipei',
            offset: -28800,
            display: 'GMT+08:00',
            name: 'Taipei'
        },
        {
            timezone: 'Asia/Bangkok',
            offset: -25200,
            display: 'GMT+07:00',
            name: 'Bangkok, Hanoi, Jakarta'
        },
        {
            timezone: 'Asia/Novosibirsk',
            offset: -25200,
            display: 'GMT+07:00',
            name: 'Novosibirsk'
        },
        {
            timezone: 'Asia/Rangoon',
            offset: -23400,
            display: 'GMT+06:30',
            name: 'Yangon Rangoon'
        },
        {
            timezone: 'Asia/Dhaka',
            offset: -21600,
            display: 'GMT+06:00',
            name: 'Astana, Dhaka'
        },
        {
            timezone: 'Asia/Yekaterinburg',
            offset: -21600,
            display: 'GMT+06:00',
            name: 'Ekaterinburg'
        },
        {
            timezone: 'Asia/Katmandu',
            offset: -20700,
            display: 'GMT+05:45',
            name: 'Kathmandu'
        },
        {
            timezone: 'Asia/Kolkata',
            offset: -19800,
            display: 'GMT+05:30',
            name: 'Chennai, Kolkata, Mumbai, New Delhi'
        },
        {
            timezone: 'Asia/Tashkent',
            offset: -18000,
            display: 'GMT+05:00',
            name: 'Asia/Tashkent'
        },
        {
            timezone: 'Asia/Kabul',
            offset: -16200,
            display: 'GMT+04:30',
            name: 'Kabul'
        },
        {
            timezone: 'Asia/Dubai',
            offset: -14400,
            display: 'GMT+04:00',
            name: 'Abu Dhabi, Muscat'
        },
        {
            timezone: 'Asia/Baku',
            offset: -14400,
            display: 'GMT+04:00',
            name: 'Baku'
        },
        {
            timezone: 'Europe/Moscow',
            offset: -14400,
            display: 'GMT+04:00',
            name: 'Moscow, St. Petersburg, Volgograd'
        },
        {
            timezone: 'Asia/Tbilisi',
            offset: -14400,
            display: 'GMT+04:00',
            name: 'Tbilisi'
        },
        {
            timezone: 'Asia/Yerevan',
            offset: -14400,
            display: 'GMT+04:00',
            name: 'Yerevan'
        },
        {
            timezone: 'Asia/Tehran',
            offset: -12600,
            display: 'GMT+03:30',
            name: 'Tehran'
        },
        {
            timezone: 'Asia/Baghdad',
            offset: -10800,
            display: 'GMT+03:00',
            name: 'Baghdad'
        },
        {
            timezone: 'Europe/Minsk',
            offset: -10800,
            display: 'GMT+03:00',
            name: 'Kaliningrad, Minsk'
        },
        {
            timezone: 'Asia/Kuwait',
            offset: -10800,
            display: 'GMT+03:00',
            name: 'Kuwait, Riyadh'
        },
        {
            timezone: 'Africa/Addis_Ababa',
            offset: -10800,
            display: 'GMT+03:00',
            name: 'Nairobi'
        },
        {
            timezone: 'Asia/Amman',
            offset: -7200,
            display: 'GMT+02:00',
            name: 'Amman'
        },
        {
            timezone: 'Europe/Bucharest',
            offset: -7200,
            display: 'GMT+02:00',
            name: 'Athens, Bucharest'
        },
        {
            timezone: 'Asia/Beirut',
            offset: -7200,
            display: 'GMT+02:00',
            name: 'Beirut'
        },
        {
            timezone: 'Africa/Cairo',
            offset: -7200,
            display: 'GMT+02:00',
            name: 'Cairo'
        },
        {
            timezone: 'Asia/Damascus',
            offset: -7200,
            display: 'GMT+02:00',
            name: 'Damascus'
        },
        {
            timezone: 'Africa/Blantyre',
            offset: -7200,
            display: 'GMT+02:00',
            name: 'Harare, Pretoria'
        },
        {
            timezone: 'Europe/Helsinki',
            offset: -7200,
            display: 'GMT+02:00',
            name: 'Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius'
        },
        {
            timezone: 'Europe/Istanbul',
            offset: -7200,
            display: 'GMT+02:00',
            name: 'Istanbul'
        },
        {
            timezone: 'Asia/Jerusalem',
            offset: -7200,
            display: 'GMT+02:00',
            name: 'Jerusalem'
        },
        {
            timezone: 'Europe/Nicosia',
            offset: -7200,
            display: 'GMT+02:00',
            name: 'Nicosia'
        },
        {
            timezone: 'Europe/Amsterdam',
            offset: -3600,
            display: 'GMT+01:00',
            name: 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'
        },
        {
            timezone: 'Europe/Belgrade',
            offset: -3600,
            display: 'GMT+01:00',
            name: 'Belgrade, Bratislava, Budapest, Prague, Ljubljana'
        },
        {
            timezone: 'Europe/Brussels',
            offset: -3600,
            display: 'GMT+01:00',
            name: 'Brussels, Copenhagen, Madrid, Paris'
        },
        {
            timezone: 'Europe/Warsaw',
            offset: -3600,
            display: 'GMT+01:00',
            name: 'Sarajevo, Skopje, Warsaw, Zagreb'
        },
        {
            timezone: 'Africa/Algiers',
            offset: -3600,
            display: 'GMT+01:00',
            name: 'West Central Africa'
        },
        {
            timezone: 'Africa/Windhoek',
            offset: -7200,
            display: 'GMT+01:00',
            name: 'Windhoek'
        },
        {
            timezone: 'Africa/Casablanca',
            offset: 0,
            display: 'GMT-00:00',
            name: 'Casablanca'
        },
        {
            timezone: 'Etc/UTC',
            offset: 0,
            display: 'GMT-00:00',
            name: 'Coordinated Universal Time'
        },
        {
            timezone: 'Africa/Abidjan',
            offset: 0,
            display: 'GMT-00:00',
            name: 'Monrovia, Reykjavik'
        },
        {
            timezone: 'Europe/London',
            offset: 0,
            display: 'GMT-00:00',
            name: 'Dublin, Lisabon, London, Edinburgh'
        },
        {
            timezone: 'Atlantic/Cape_Verde',
            offset: 3600,
            display: 'GMT-01:00',
            name: 'Cape Verde Is.'
        },
        {
            timezone: 'Atlantic/Azores',
            offset: 3600,
            display: 'GMT-01:00',
            name: 'Azores'
        },
        {
            timezone: 'America/Noronha',
            offset: 7200,
            display: 'GMT-02:00',
            name: 'Mid-Atlantic'
        },
        {
            timezone: 'Etc/GMT+2',
            offset: 7200,
            display: 'GMT-02:00',
            name: 'Coordinated Universal Time - 02'
        },
        {
            timezone: 'America/Sao_Paulo',
            offset: 7200,
            display: 'GMT-03:00',
            name: 'Brasilia'
        },
        {
            timezone: 'America/Argentina/Buenos_Aires',
            offset: 10800,
            display: 'GMT-03:00',
            name: 'Buenos Aires'
        },
        {
            timezone: 'America/Cayenne',
            offset: 10800,
            display: 'GMT-03:00',
            name: 'Cayenne, Fortalenza'
        },
        {
            timezone: 'America/Godthab',
            offset: 10800,
            display: 'GMT-03:00',
            name: 'Greenland'
        },
        {
            timezone: 'America/Montevideo',
            offset: 7200,
            display: 'GMT-03:00',
            name: 'Montevideo'
        },
        {
            timezone: 'America/St_Johns',
            offset: 12600,
            display: 'GMT-03:30',
            name: 'Newfoundland'
        }
    ]
}